// extracted by mini-css-extract-plugin
export var productImage = "_qh-1";
export var viewLink = "_qh-2";
export var wishlistItem = "_qh-0";